/*
 * JobDetails Messages
 *
 * This contains all the text for the JobDetails component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'src.pages.ProjectDetailsPage.components.JobDetails';

export default defineMessages({
  validityScoreLabel: {
    id: `${scope}.validityScoreLabel`,
    defaultMessage: 'Validity score',
  },
  lastRenewalLabel: {
    id: `${scope}.lastRenewalLabel`,
    defaultMessage: 'Last renewal',
  },
  applicantLabel: {
    id: `${scope}.applicantLabel`,
    defaultMessage: 'Applicant',
  },
  appliedToLabel: {
    id: `${scope}.appliedToLabel`,
    defaultMessage: 'Applied to',
  },
  workdayLabel: { id: `${scope}.workdayLabel`, defaultMessage: 'Workdays' },
  daysSinceAppliedLabel: {
    id: `${scope}.daysSinceAppliedLabel`,
    defaultMessage: 'Day since applied',
  },
  daysSinceAcceptedLabel: {
    id: `${scope}.daysSinceAcceptedLabel`,
    defaultMessage: 'Day since accepted',
  },
  cancelRateLabel: {
    id: `${scope}.cancelRateLabel`,
    defaultMessage: 'Cancel Rate',
  },
  timeToConfirmLabel: {
    id: `${scope}.timeToConfirmLabel`,
    defaultMessage: 'Time to confirm',
  },
  logInLabel: { id: `${scope}.logInLabel`, defaultMessage: 'Log in' },
  ratingLabel: { id: `${scope}.ratingLabel`, defaultMessage: 'Rating' },
  preScreenLabel: {
    id: `${scope}.preScreenLabel`,
    defaultMessage: 'Pre-Screen',
  },
  profileLabel: { id: `${scope}.profileLabel`, defaultMessage: 'Profile' },
  lastJobLabel: { id: `${scope}.lastJobLabel`, defaultMessage: 'Last job' },
  statusLabel: { id: `${scope}.statusLabel`, defaultMessage: 'Status' },
  statusReasonLabel: {
    id: `${scope}.statusReasonLabel`,
    defaultMessage: 'Status / Reason',
  },
  briefingLabel: { id: `${scope}.briefingLabel`, defaultMessage: 'Briefing' },
  preJobQLabel: { id: `${scope}.preJobQLabel`, defaultMessage: 'Pre-Job Q' },
  contractSummaryLabel: {
    id: `${scope}.contractSummaryLabel`,
    defaultMessage: 'Contract status',
  },
  daySinceAppliedLabel: {
    id: `${scope}.daySinceAppliedLabel`,
    defaultMessage: 'Day since applied',
  },
  checkInLabel: { id: `${scope}.checkInLabel`, defaultMessage: 'Check-in' },
  checkOutLabel: { id: `${scope}.checkOutLabel`, defaultMessage: 'Check-out' },
  commentLabel: { id: `${scope}.commentLabel`, defaultMessage: 'Comment' },
  scoreLabel: { id: `${scope}.scoreLabel`, defaultMessage: 'Score' },
  commentField: { id: `${scope}.commentField`, defaultMessage: 'Comment' },
  toTransferLabel: {
    id: `${scope}.toTransferLabel`,
    defaultMessage: 'To transfer',
  },
  transferredByLabel: {
    id: `${scope}.transferredByLabel`,
    defaultMessage: 'Transferred by',
  },
  saveRatingButton: {
    id: `${scope}.saveRatingButton`,
    defaultMessage: 'Save rating',
  },
  confirmAcceptButton: {
    id: `${scope}.confirmAcceptButton`,
    defaultMessage: 'Accept Selected',
  },
  acceptSuggestionButton: {
    id: `${scope}.acceptSuggestionButton`,
    defaultMessage: 'Accept',
  },
  rejectSuggestionButton: {
    id: `${scope}.rejectSuggestionButton`,
    defaultMessage: 'Reject',
  },
  acceptModalLabel: {
    id: `${scope}.acceptModalLabel`,
    defaultMessage: 'Please specify a reason for accepting',
  },
  confirmRejectButton: {
    id: `${scope}.confirmRejectButton`,
    defaultMessage: 'Reject Selected',
  },
  rejectModalLabel: {
    id: `${scope}.rejectModalLabel`,
    defaultMessage: 'Please specify a reason for rejecting',
  },
  mainJobCard: { id: `${scope}.mainJobCard`, defaultMessage: 'Main Job' },
  standbyCard: { id: `${scope}.standbyCard`, defaultMessage: 'Standby' },
  incompleteLabel: {
    id: `${scope}.incompleteLabel`,
    defaultMessage: 'Incomplete',
  },
  completeLabel: { id: `${scope}.completeLabel`, defaultMessage: 'Complete' },
  confirmedBriefingLabel: {
    id: `${scope}.confirmedBriefingLabel`,
    defaultMessage: 'Confirmed',
  },
  daysSinceBookedLabel: {
    id: `${scope}.daysSinceBookedLabel`,
    defaultMessage: 'Days since booked',
  },
  languagesColumnLabel: {
    id: `${scope}.languagesColumnLabel`,
    defaultMessage: 'Languages',
  },
  initialScoreColumnLabel: {
    id: `${scope}.initialScoreColumnLabel`,
    defaultMessage: 'Gut feeling',
  },
  reapplyTooltip: {
    id: `${scope}.reapplyTooltip`,
    defaultMessage: 'Re-apply',
  },
  reapplyApplicationConfirmMessage: {
    id: `${scope}.reapplyApplicationConfirmMessage`,
    defaultMessage: 'Are you sure you want to apply back to this Job?',
  },
  cancelRejectButton: {
    id: `${scope}.cancelRejectButton`,
    defaultMessage: 'Cancel',
  },
  rejectButton: {
    id: `${scope}.rejectButton`,
    defaultMessage: 'Reject',
  },
  hiddenLabel: {
    id: `${scope}.hiddenLabel`,
    defaultMessage: 'Hidden',
  },
  visibleLabel: {
    id: `${scope}.visibleLabel`,
    defaultMessage: 'Visible',
  },
  waitlistedLabel: {
    id: `${scope}.waitlistedLabel`,
    defaultMessage: 'waitlisted',
  },
  acceptBulkButton: {
    id: `${scope}.acceptBulkButton`,
    defaultMessage: 'Accept all shifts',
  },
  rejectBulkButton: {
    id: `${scope}.rejectBulkButton`,
    defaultMessage: 'Reject all shifts',
  },
  today: {
    id: `${scope}.today`,
    defaultMessage: 'today',
  },
  applicantWorksToday: {
    id: `${scope}.applicantWorksToday`,
    defaultMessage: 'Applicant works or worked today',
  },
  applicantWorkedYesterday: {
    id: `${scope}.applicantWorkedYesterday`,
    defaultMessage: 'Applicant worked yesterday',
  },
  applicantWorkedDaysAgo: {
    id: `${scope}.applicantWorkedDaysAgo`,
    defaultMessage: 'Applicant worked {days} days ago',
  },
  applicantWillWorkTomorrow: {
    id: `${scope}.applicantWillWorkTomorrow`,
    defaultMessage: 'Applicant is going to work tomorrow',
  },
  applicantWillWorkInDays: {
    id: `${scope}.applicantWillWorkInDays`,
    defaultMessage: 'Applicant is going to work in {days} days',
  },
  suggestedByAutoBooking: {
    id: `${scope}.suggestedByAutoBooking`,
    defaultMessage: 'SUGGESTED BY AUTO BOOKING',
  },
  notSuggested: {
    id: `${scope}.notSuggested`,
    defaultMessage: 'NOT SUGGESTED',
  },
  abReasoningLabel: {
    id: `${scope}.abReasoningLabel`,
    defaultMessage: 'AB reasoning',
  },
  suggestionLabel: {
    id: `${scope}.suggestionLabel`,
    defaultMessage: 'Suggestion',
  },
  acceptSuggestionConfirm: {
    id: `${scope}.acceptSuggestionConfirm`,
    defaultMessage: 'Are you sure you want to accept this suggestion?',
  },
  rejectionReasonTitle: {
    id: `${scope}.rejectionReasonTitle`,
    defaultMessage: 'Rejection Reason',
  },
  rejectionReasonHelper: {
    id: `${scope}.rejectionReasonHelper`,
    defaultMessage: 'Please provide a reason for rejecting this suggestion.',
  },
  reasonLabel: {
    id: `${scope}.reasonLabel`,
    defaultMessage: 'Reason',
  },
  suggestedCount: {
    id: `${scope}.suggestedCount`,
    defaultMessage: '{count} suggested',
  },
  vetoButton: {
    id: `${scope}.vetoButton`,
    defaultMessage: 'Veto',
  },
  vetoReasonTitle: {
    id: `${scope}.vetoReasonTitle`,
    defaultMessage: 'Veto Reason',
  },
  vetoReasonHelper: {
    id: `${scope}.vetoReasonHelper`,
    defaultMessage: 'Please provide a reason for vetoing this application.',
  },
  confirmButton: {
    id: `${scope}.confirmButton`,
    defaultMessage: 'Confirm',
  },
  abReasonTimeConflict: {
    id: `${scope}.abReasonTimeConflict`,
    defaultMessage: 'Shift conflict',
  },
  abReasonGroupNotInRun: {
    id: `${scope}.abReasonGroupNotInRun`,
    defaultMessage: 'Shift not in scope',
  },
  abReasonNoActiveContract: {
    id: `${scope}.abReasonNoActiveContract`,
    defaultMessage: 'No active contract',
  },
  abReasonMissingCity: {
    id: `${scope}.abReasonMissingCity`,
    defaultMessage: 'Desired city doesn’t match',
  },
  abReasonLowBehaviorScore: {
    id: `${scope}.abReasonLowBehaviorScore`,
    defaultMessage: 'Behavior score too low',
  },
  abReasonShiftFullyBooked: {
    id: `${scope}.abReasonShiftFullyBooked`,
    defaultMessage: 'Shift fully booked',
  },
  abReasonExcludedBySolver: {
    id: `${scope}.abReasonExcludedBySolver`,
    defaultMessage: 'Evaluated but not selected',
  },
  abReasonWeeklyLimitReached: {
    id: `${scope}.abReasonWeeklyLimitReached`,
    defaultMessage: 'Weekly work limit reached',
  },
  abReasonYearlyLimitReached: {
    id: `${scope}.abReasonYearlyLimitReached`,
    defaultMessage: 'Yearly work limit reached',
  },
  abReasonMissingCertificate: {
    id: `${scope}.abReasonMissingCertificate`,
    defaultMessage: 'Required certificate missing',
  },
  abReasonRestPeriodViolation: {
    id: `${scope}.abReasonRestPeriodViolation`,
    defaultMessage: '11-hour rest time violated',
  },
  abReasonMissingLanguageRequirement: {
    id: `${scope}.abReasonMissingLanguageRequirement`,
    defaultMessage: 'Language requirement not met',
  },
});
